import { Stack } from '@mui/material';
import { styled } from '@mui/system';
import _ from 'lodash';
import React, { useCallback } from 'react';
import { useDeepCompareEffect } from 'react-use';
import { ModalText, useModalToggle } from '../components/modal/Modal';
import { OkModal } from '../components/modal/OkModal';

export const makeYupValidator = (schema: any) => async (data: any) => {
  try {
    const values = await schema.validate(data, {
      abortEarly: false,
    });

    return {
      values,
      errors: {},
    };
  } catch (errors: any) {
    return {
      values: {},
      errors: errors.inner?.reduce(
        (allErrors: any, currentError: any) => ({
          ...allErrors,
          [currentError.path]: {
            type: currentError.type ?? 'validation',
            message: currentError.message,
          },
        }),
        {},
      ),
    };
  }
};

export const useYupValidationResolver = (validationSchema: any) => {
  const resolver = useCallback(
    (data: any) => makeYupValidator(validationSchema)(data),
    [validationSchema],
  );

  return resolver;
};

const Text = styled('p')`
  color: #b12310;
  font-size: 14px;
`;

export function ErrorMsg({ form, name, ...rest }: any) {
  const fieldName = typeof name === 'string' ? name : _.first(name);
  const errMsg = _.get(form, `formState.errors.${fieldName}.message`);
  return !!errMsg ? <Text {...rest}>{errMsg}</Text> : <></>;
}

const MsgWrap = styled(Stack)`
  min-width: 360px;
  max-height: 180px;
  overflow-y: scroll;

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none;
  }
`;
export function FormErrorModal({
  form,
  exclusionFields = [] as string[],
  title = '',
  onClose = _.noop,
}: any) {
  const fields = _.difference(_.keys(form.formState.errors), exclusionFields);
  const errMsgs = fields
    .map(it => {
      const err = _.get(form.formState.errors, `${it}`);
      return _.get(err, 'message');
    })
    .filter(_.identity);

  const { open, close, on } = useModalToggle();
  useDeepCompareEffect(() => {
    if (!_.isEmpty(errMsgs)) {
      open();
    } else {
      close();
    }
  }, [errMsgs, open, close]);
  return (
    <OkModal
      title={title}
      on={on}
      onClose={() => {
        onClose({ fields, errMsgs });
        form.clearErrors(fields);
        close();
      }}
    >
      <MsgWrap>
        {errMsgs.map((it, index) => (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            sx={{ mb: 4 }}
            key={index}
          >
            <img
              src={require('../app/static/images/warning.png')}
              alt="체크표시"
            />
            <ModalText sx={{ ml: 2 }}>
              [{index + 1}] {it}
            </ModalText>
          </Stack>
        ))}
      </MsgWrap>
    </OkModal>
  );
}
